import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { FiArrowLeft } from 'react-icons/fi'

export default function LegalLayout({ title, description, lastUpdate, canonicalPath, children }) {
  return (
    <>
      <Helmet>
        <title>{title} | PresenzIA</title>
        <meta name="description" content={description} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://presenzia.app${canonicalPath}`} />
      </Helmet>

      <div className="min-h-screen bg-white">
        <nav className="sticky top-0 z-40 bg-white/90 backdrop-blur-xl border-b border-gray-100">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 flex items-center justify-between h-14">
            <Link to="/landing" className="flex items-center gap-2">
              <img src="/logo-presenzia-icon.svg" alt="PresenzIA" className="w-8 h-8 rounded-lg" />
              <span className="text-lg font-bold text-gray-900">
                Presenz<span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 to-cyan-500">IA</span>
              </span>
            </Link>
            <Link to="/landing" className="text-sm font-medium text-gray-600 hover:text-blue-600">
              Volver al inicio
            </Link>
          </div>
        </nav>

        <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-6">
          <Link to="/landing" className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-blue-600">
            <FiArrowLeft className="h-3.5 w-3.5" /> Volver
          </Link>
        </div>

        <article className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
          <header className="mb-8 pb-6 border-b border-gray-100">
            <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 leading-tight mb-2">{title}</h1>
            {lastUpdate && (
              <p className="text-sm text-gray-500">Última actualización: {lastUpdate}</p>
            )}
          </header>
          <div className="prose prose-gray prose-lg max-w-none prose-headings:text-gray-900 prose-headings:font-bold prose-p:text-gray-700 prose-p:leading-relaxed prose-a:text-blue-600 prose-strong:text-gray-900 prose-li:text-gray-700">
            {children}
          </div>
        </article>

        <footer className="border-t border-gray-100 py-8">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 text-sm text-gray-500 text-center space-x-4">
            <Link to="/aviso-legal" className="hover:text-blue-600">Aviso legal</Link>
            <Link to="/privacidad" className="hover:text-blue-600">Privacidad</Link>
            <Link to="/cookies" className="hover:text-blue-600">Cookies</Link>
          </div>
        </footer>
      </div>
    </>
  )
}
